import { Button } from "@tql/ui-components-react/tql/buttons";
import { chevronLeft } from "@tql/ui-components-react/untitled/icons";
import type { ReactNode } from "react";
import { useNavigate } from "react-router";

import { routes } from "~/app/routes/web-routes.ts";
import { CustomerSearch } from "~/shared/components/customer-search/customer-search.tsx";
import { TraxPageHeader } from "~/shared/components/trax-page-header/trax-page-header.tsx";
import { TraxPageLayout } from "~/shared/components/trax-page-layout/trax-page-layout.tsx";
import { useDeploymentType } from "~/shared/hooks/use-deployment-type.ts";
import { useIsMobile } from "~/shared/hooks/use-is-mobile.ts";
import type { Customer } from "~/shared/types/quote-details-types.ts";

import styles from "./report-detail.module.css";

type ReportDetailProps = {
	readonly title: string;
	readonly children: ReactNode | ((mobileHeader: ReactNode) => ReactNode);
	readonly selectedCustomer: Customer | undefined;
	readonly onCustomerChange: (customer: Customer | null) => void;
};

export function ReportDetail({
	title,
	children,
	selectedCustomer,
	onCustomerChange,
}: ReportDetailProps) {
	const navigate = useNavigate();
	const isMobile = useIsMobile();
	const { isInternal } = useDeploymentType();
	const mobileHeader = (
		<>
			<h4 className={styles.reportDetailTitle}>{title}</h4>
			<h4 className={styles.reportDetailCustomerSearchTitle}>
				Customer Search
			</h4>
			<div className={styles.reportDetailCustomerSearchWrapper}>
				<CustomerSearch
					onCustomerChange={onCustomerChange}
					selectedCustomer={selectedCustomer}
				/>
			</div>
		</>
	);
	const isRenderFunction = typeof children === "function";

	return (
		<TraxPageLayout className={styles.reportDetailShell}>
			<div className={styles.reportDetailWrapper}>
				<div>
					<Button
						onClick={() => {
							navigate(routes.reports);
						}}
						svgIcon={chevronLeft}
						variant={"tertiary"}
					>
						Back to Reports Dashboard
					</Button>
				</div>
				{isMobile ? (
					<TraxPageHeader
						representativeType={isInternal ? undefined : "ltl"}
						showSupportMessage={!isInternal}
						title={"Reports"}
					/>
				) : null}
				<div className={styles.reportDetailContainer}>
					{!isRenderFunction || !isMobile ? mobileHeader : null}
					{isRenderFunction ? children(mobileHeader) : children}
				</div>
			</div>
		</TraxPageLayout>
	);
}
